/**
 * @file: formatErpProviderTitle.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { ErpProviderInfo } from '@euler/model/erp-integrations';

/**
 * How a provider is named to the user: the company, then the product.
 *
 * Several catalog entries repeat the company inside the product name
 * (`黑谷科技` / `黑谷`, `嘛雀` / `嘛雀`), so the shared prefix is dropped
 * before joining and an entry that carries no product beyond its own name
 * renders as the name alone.
 */
export const formatErpProviderTitle = (
  provider: Pick<ErpProviderInfo, 'name' | 'productName'> | undefined,
  fallback: string,
): string => {
  if (!provider?.name) {
    return fallback;
  }
  const { name, productName } = provider;
  if (!productName) {
    return name;
  }

  let shared = 0;
  while (
    shared < name.length &&
    shared < productName.length &&
    name[shared] === productName[shared]
  ) {
    shared += 1;
  }

  const product = productName.slice(shared).trim();
  return product ? `${name} · ${product}` : name;
};
